import { RootState } from 'editor/src/store/index';

const getIsLoading = (state: RootState) => state.editor.isLoading;

export default getIsLoading;
